import React, { useState, useContext, useEffect } from "react";
import { DesignProgramContext } from "../pages/CustomHooks/ContextApi";

const DevicePriority = () => {
  const { derPriority, setDerPriority } = useContext(DesignProgramContext);
  const [selectedData, setSelectedData] = useState(derPriority);
  const [initialData, setInitialData] = useState(derPriority);
  const priorityTypes = ["pmPriority", "cbPriority", "derPriority"];

  useEffect(() => {
    setDerPriority(selectedData);
  }, [selectedData]);
  const handlePriorityChange = (category, changedType, newValueStr) => {
    const newValue = parseInt(newValueStr);

    setSelectedData((prevData) => {
      const newCategoryState = { ...prevData[category] };
      newCategoryState[changedType] = newValue;

      const priorityTypes = ["pmPriority", "cbPriority", "derPriority"];

      const adjustOtherPriorities = () => {
        const otherTypes = priorityTypes.filter(
          (type) => type !== changedType && newCategoryState[type] !== 0
        );

        if (newValue === 1) {
          otherTypes.forEach((type, index) => {
            newCategoryState[type] = index + 2;
          });
        } else if (newValue === 2) {
          if (otherTypes.length === 1) {
            newCategoryState[otherTypes[0]] = 1;
          } else if (otherTypes.length === 2) {
            newCategoryState[otherTypes[0]] = 1;
            newCategoryState[otherTypes[1]] = 3;
          }
        } else if (newValue === 3) {
          otherTypes.forEach((type, index) => {
            newCategoryState[type] = index + 1;
          });
        }
      };

      adjustOtherPriorities();
      if (category === "Utility" || category === "Load") {
        newCategoryState.derPriority = 0;
      }

      return {
        ...prevData,
        [category]: newCategoryState,
      };
    });
  };

  const derAssetsList = {
    Utility: 0,
    Genset: 1,
    BESS: 2,
    Inverter: 3,
    Load: 4,
    "Circuit Breaker": 5,
    "Power Meter": 6,
  };

  const getPriority = (key) => {
    if (key.startsWith("Load")) {
      return derAssetsList.Load;
    } else if (key === "BESS") {
      return derAssetsList.BESS;
    } else if (key === "Utility") {
      return derAssetsList.Utility;
    } else {
      return derAssetsList.Genset;
    }
  };

  const getAvailablePriorities = (category, type) => {
    const isUtilityOrLoad =
      category === "Utility" || category.toLowerCase().includes("load");
    const pmPriority = selectedData[category]?.pmPriority;
    const derPriority = selectedData[category]?.derPriority;
    const cbPriority = selectedData[category]?.cbPriority;
    if (isUtilityOrLoad && type === "derPriority") {
      return [0];
    }
    if (
      (pmPriority === 0 && derPriority === 0) ||
      (pmPriority === 0 && cbPriority === 0) ||
      (derPriority === 0 && cbPriority === 0)
    ) {
      return [1];
    }
    if (pmPriority === 0 || cbPriority === 0 || derPriority === 0) {
      return [1, 2];
    }
    return isUtilityOrLoad ? [1, 2] : [1, 2, 3];
  };

  const resetDevicePriority = () => {
    setSelectedData(initialData);
  };

  const saveDevicePriority = () => {
    console.log("selectedData", selectedData);
  };

  return (
    <div>
      <div className="d-flex justify-content-end">
        <se-button color="primary" onClick={resetDevicePriority}>
          Reset
        </se-button>
      </div>

      <div className="table-responsive mt-2">
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>DERS Name</th>
              <th>PM Priority</th>
              <th>CB Priority</th>
              <th>DER Priority</th>
            </tr>
          </thead>
          <tbody>
            {Object.keys(selectedData)
              .sort((a, b) => {
                return getPriority(a) - getPriority(b);
              })
              .map((category) => (
                <tr key={category}>
                  <td>{category}</td>
                  <td>
                    {selectedData[category]?.pmPriority === 0 ? (
                      <div style={{ textAlign: "center", paddingTop: "9px" }}>
                        NA
                      </div>
                    ) : (
                      <select
                        className="form-control form-control-sm"
                        value={selectedData[category]?.pmPriority ?? 1}
                        onChange={(e) =>
                          handlePriorityChange(
                            category,
                            "pmPriority",
                            e.target.value
                          )
                        }
                      >
                        {getAvailablePriorities(category, "pmPriority").map(
                          (priority) => (
                            <option key={priority} value={priority}>
                              {priority}
                            </option>
                          )
                        )}
                      </select>
                    )}
                  </td>
                  <td>
                    {selectedData[category]?.cbPriority === 0 ? (
                      <div style={{ textAlign: "center", paddingTop: "9px" }}>
                        NA
                      </div>
                    ) : (
                      <select
                        className="form-control form-control-sm"
                        value={selectedData[category]?.cbPriority ?? 2}
                        onChange={(e) =>
                          handlePriorityChange(
                            category,
                            "cbPriority",
                            e.target.value
                          )
                        }
                      >
                        {getAvailablePriorities(category, "cbPriority").map(
                          (priority) => (
                            <option key={priority} value={priority}>
                              {priority}
                            </option>
                          )
                        )}
                      </select>
                    )}
                  </td>
                  <td>
                    {category === "Utility" ||
                    category.toLowerCase().includes("load") ? (
                      <div style={{ textAlign: "center", paddingTop: "9px" }}>
                        NA
                      </div>
                    ) : (
                      <select
                        className="form-control form-control-sm"
                        value={selectedData[category]?.derPriority ?? 0}
                        onChange={(e) =>
                          handlePriorityChange(
                            category,
                            "derPriority",
                            e.target.value
                          )
                        }
                      >
                        {getAvailablePriorities(category, "derPriority").map(
                          (priority) => (
                            <option key={priority} value={priority}>
                              {priority}
                            </option>
                          )
                        )}
                      </select>
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DevicePriority;
